export const linuxImages = Array.from({ length: 7 }, (_, i) => 
    require(`../../statics/img/guest/Linux0${i}.png`)
); 